import { render, staticRenderFns } from "./Jump.vue?vue&type=template&id=056f9701&"
import script from "./Jump.vue?vue&type=script&lang=js&"
export * from "./Jump.vue?vue&type=script&lang=js&"
import style0 from "./Jump.vue?vue&type=style&index=0&id=056f9701&prod&lang=scss&scope=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports